<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card no-body class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-brand href="#" class="text-dark">
                <strong style="color:#3b3e66">Email Tags</strong>
              </b-navbar-brand>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    @click="showAddTagModal = !showAddTagModal"
                    class="mr-2"
                    variant="outline-primary"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />
                  </b-button>
                  <b-button variant="outline-info" size="sm" class="mr-4" @click="reloadTable">
                    <font-awesome-icon icon="sync" />
                  </b-button>
                  <b-form-group>
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
            <b-table
              sticky-header="calc(100vh - 295px)"
              :busy.sync="isLoading"
              bordered
              hover
              striped
              ref="table"
              id="tag-table"
              :fields="staticFields"
              :items="getTagData"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(is_active)="data">
                <b-badge
                  :variant="data.item.is_active == 1 ? 'success' : 'danger'"
                >{{ data.item.is_active == 1 ? 'Active' : 'In Active'}}</b-badge>
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn @click="editTag(data)" class="mr-2" size="sm" variant="outline-info">
                  <font-awesome-icon icon="edit" />
                </b-btn>
              </template>
            </b-table>

            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Showing Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="tag-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="isEditTag ? 'Update Tag' : 'Add Tag'"
      size="lg"
      scrollable
      v-model="showAddTagModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label class="text-left">Tag:</label>
                <b-form-input v-model="form.tag" size="sm" type="text"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group style="margin-top: 30px;">
                <b-form-checkbox v-model="form.isActive" switch>Is Active</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ isEditTag ? 'Your Tag is being Updateing......' : 'Your Tag is being Creating......' }}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditTag ? 'Your Tag has been updated successfully.' : 'Your Tag has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" @click="resetModal" variant="outline-danger">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{ isEditTag ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import { Helper } from "../../../helpers";
export default {
  name: "EmailTags",
  data() {
    return {
      isEditTag: false,
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      showAddTagModal: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      toRows: 0,
      fromRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Created Date", sortable: true },
        { key: "tag", label: "Tag", sortable: true },
        { key: "is_active", label: "Status", sortable: true },
        { key: "actions", label: "Action", sortable: false },
      ],
      form: {
        tag: null,
        isActive: true,
      },
      tagId: null,
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  methods: {
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "tag-table");
    },
    async getTagData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let result = HTTP("post", "api/v1/tag/get", formData);

      return result
        .then((response) => {
          const items = response.data.data;
          this.isLoading = false;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
    resetForm() {
      this.form = {
        tag: null,
        isActive: true,
      };
    },
    resetModal() {
      this.resetForm();
      this.tagId = null;
      this.isEditTag = false;
      this.showAddTagModal = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    checkValidation() {
      if (this.isEditTag) {
        this.updateApprovalType().then(this.reloadTable);
      } else {
        this.saveApprovalType().then(this.reloadTable);
      }
    },
    async saveApprovalType() {
      let formData = {
        tag: this.form.tag,
        is_active: this.form.isActive ? 1 : 0,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP("post", "api/v1/tag/create", formData);
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if (result.data.status == 1) {
          this.makeToster("success", result.data.message);
        } else {
          this.makeToster("danger", result.data.message);
        }
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async updateApprovalType() {
      let formData = {
        tag: this.form.tag,
        is_active: this.form.isActive ? 1 : 0,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP("put", "api/v1/tag/" + this.tagId, formData);
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if (result.data.status == 1) {
          this.makeToster("success", result.data.message);
        } else {
          this.makeToster("danger", result.data.message);
        }
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    editTag(data) {
      this.isEditTag = true;
      this.tagId = data.item.id;
      this.form = {
        tag: data.item.tag,
        isActive: data.item.is_active == 1 ? true : false,
      };
      this.showAddTagModal = true;
    },
    makeToster(tosterVarient, tosterMsg) {
      this.resetModal();
      Helper.makeToast(this.$bvToast, tosterVarient, tosterMsg);
    },
  },
};
</script>
<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";
/* @import "../../../assets/styles/theme1/card.css"; */
@import "../../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>